<template>
  <main class="main">
    <ol class="breadcrumb-trail__list">
      <li class="breadcrumb-trail__list--item">
        <router-link
          :to="{ path: `/${langPath}` }"
          class="breadcrumb-trail__list--item__link"
        >
          TOP
        </router-link>
      </li>
      <li class="breadcrumb-trail__list--item">
        <router-link
          :to="{ path: `/${langPath}howtojoin` }"
          class="breadcrumb-trail__list--item__link"
        >
          How to Join
        </router-link>
      </li>
    </ol>
    <h1 class="how-to-join-title">How to Join</h1>
    <h2 class="about-title">
      {{ HowToJoin.aboutTitle[lang] }}
    </h2>
    <p class="about-virtualrun">
      {{ HowToJoin.about[lang] }}
    </p>
    <h2 class="howtojoin-flow">
      {{ HowToJoin.participationFlow[lang] }}
    </h2>
    <ol>
      <li class="flow__list--item">
        <h3 class="step-title">STEP 1</h3>
        <p class="status-label">
          {{ HowToJoin.step1.flow[lang] }}
        </p>
        <h4 class="flow-title">
          {{ HowToJoin.step1.title[lang] }}
        </h4>
        <img
          class="flow-img"
          src="../../../assets/images/flow/step_01.svg"
          alt=""
          width="200px"
          height="200px"
        />
        <h5 class="suggestion">
          {{ HowToJoin.step1.suggestion[lang] }}
        </h5>
        <p class="important-points">
          {{ HowToJoin.step1.point[lang]
          }}<router-link v-scroll-to="'#app-use-list'" to="" class="t-underline"
            >{{ HowToJoin.here[lang] }}
          </router-link>
          {{ HowToJoin.step1.point2[lang] }}
        </p>
      </li>
      <li class="flow__list--item">
        <h3 class="step-title">STEP 2</h3>
        <p class="status-label">
          {{ HowToJoin.step2.flow[lang] }}
        </p>
        <h4 class="flow-title">
          {{ HowToJoin.step2.title[lang] }}
        </h4>
        <img
          class="flow-img"
          src="../../../assets/images/flow/step_02.svg"
          alt=""
          width="200px"
          height="200px"
        />
        <h5 class="suggestion">
          {{ HowToJoin.step2.suggestion[lang] }}
        </h5>
        <p class="important-points">
          {{ HowToJoin.step2.point[lang]
          }}<router-link
            :to="{ path: `/${langPath}`, query: { from: 'htj' } }"
            class="t-underline"
            >{{ HowToJoin.here[lang] }}
          </router-link>
        </p>
      </li>
      <li class="flow__list--item">
        <div class="border-important" :class="`height-${lang}`"></div>
        <p class="important flex-all-center">
          {{ HowToJoin.step3.important[lang] }}
        </p>
        <h3 class="step-title">STEP 3</h3>
        <p class="status-label">
          {{ HowToJoin.step3.flow[lang] }}
        </p>
        <h4 class="flow-title important-height">
          {{ HowToJoin.step3.title[lang] }}
        </h4>
        <img
          class="flow-img"
          src="../../../assets/images/flow/step_03.svg"
          alt=""
          width="200px"
          height="200px"
        />
        <h5 class="suggestion">
          {{ HowToJoin.step3.suggestion[lang] }}
        </h5>
        <p class="important-points">
          <span v-html="HowToJoin.step3.point[lang]"></span>
          <span class="color-red">
            {{ HowToJoin.step3.appLinkSetting[lang]
            }}<a
              :href="HowToJoin.step3.pdf[lang]"
              target="_blank"
              rel="noopener"
              class="color-red t-underline ga-flow"
              >{{ HowToJoin.here[lang] }}</a
            >
            {{ HowToJoin.step3.appCoopConfirm[lang]
            }}<a
              :href="HowToJoin.step3.pdf2[lang]"
              target="_blank"
              rel="noopener"
              class="color-red t-underline ga-flow"
              >{{ HowToJoin.here[lang] }}</a
            >
          </span>
        </p>
      </li>
      <li class="flow__list--item">
        <h3 class="step-title">STEP 4</h3>
        <p class="status-label">
          {{ HowToJoin.step4.flow[lang] }}
        </p>
        <h4 class="flow-title">
          {{ HowToJoin.step4.title[lang] }}
        </h4>
        <img
          class="flow-img"
          src="../../../assets/images/flow/step_04.svg"
          alt=""
          width="200px"
          height="200px"
        />
        <h5 class="suggestion">
          {{ HowToJoin.step4.suggestion[lang] }}
        </h5>
        <h6 class="verification">
          {{ HowToJoin.step4.verification[lang] }}
        </h6>
        <p class="verification__sentence">
          {{ HowToJoin.step4.verificationNote[lang] }}
          <br />
          {{ HowToJoin.step4.verificationNote2[lang] }}
        </p>
        <h6 class="verification">
          {{ HowToJoin.step4.verification2[lang] }}
        </h6>
        <p class="verification__sentence">
          {{ HowToJoin.step4.verification2Note[lang] }}
          <br />
          {{ HowToJoin.step4.verification2Note2[lang] }}
        </p>
      </li>
      <li class="flow__list--item">
        <h3 class="step-title">STEP 5</h3>
        <p class="status-label">{{ HowToJoin.step5.flow[lang] }}</p>
        <h4 class="flow-title">
          {{ HowToJoin.step5.title[lang] }}
        </h4>
        <img
          class="flow-img"
          src="../../../assets/images/flow/step_05.svg"
          alt=""
          width="200px"
          height="200px"
        />
        <h5 class="suggestion">
          {{ HowToJoin.step5.suggestion[lang] }}
        </h5>
        <p
          class="important-points pre-line-normal"
          v-for="(point, index) in HowToJoin.step5.points"
          :key="index"
        >
          {{ point[lang] }}
        </p>
      </li>
      <li class="flow__list--item">
        <h3 class="step-title">STEP 6</h3>
        <p class="status-label">{{ HowToJoin.step6.flow[lang] }}</p>
        <h4 class="flow-title">
          {{ HowToJoin.step6.title[lang] }}
        </h4>
        <img
          class="flow-img"
          src="../../../assets/images/flow/step_06.svg"
          alt=""
        />
        <h5 class="suggestion">
          {{ HowToJoin.step6.suggestion[lang] }}
        </h5>
        <p class="important-points">{{ HowToJoin.step6.point[lang] }}</p>
      </li>
    </ol>
    <h2 id="app-use-list" class="app-to-use">
      {{ HowToJoin.runApp[lang] }}
    </h2>
    <p class="app-description">{{ HowToJoin.runAppExplanation[lang] }}</p>
    <!--  App  -->
    <div class="app-gallery">
      <img
        class="app-gallery__img"
        src="../../../assets/images/app/runkeeper-app-logo.png"
        alt=""
        width="150"
        height="150"
      />
      <div class="app-gallery__title">ASICS Runkeeper™</div>
      <div class="app-gallery__link">
        <a :href="HowToJoin.appStore[lang]" target="_blank" rel="noopener">
          <img
            src="../../../assets/images/app/runkeeper-ios.svg"
            alt="Download on the App Store"
          />
        </a>
        <a :href="HowToJoin.googlePlay[lang]" target="_blank" rel="noopener">
          <img
            src="../../../assets/images/app/runkeeper-android.png"
            alt="Get it on Google Play"
            class="android"
          />
        </a>
      </div>
    </div>
    <h2 class="important-title">{{ HowToJoin.importantNote[lang] }}</h2>
    <ol class="important-list">
      <li
        v-for="(importantNote, index) in HowToJoin.importantNotes"
        :key="index"
        class="important-list__item"
      >
        {{ importantNote[lang] }}
      </li>
    </ol>
  </main>
</template>

<script>
import HowToJoin from "../../../assets/constants/howtojoin/howtojoin.json";
export default {
  computed: {
    HowToJoin: function () {
      return HowToJoin;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  name: "CommonHowToJoin",
};
</script>

<style scoped>
h2 {
  font-size: 32px;
  line-height: 1.25;
}
h3 {
  font-size: 30px;
  line-height: 1;
}
h4 {
  font-size: 24px;
  line-height: 1.17;
}
h5 {
  font-size: 20px;
  line-height: 1.4;
}
h6 {
  font-size: 16px;
  line-height: 1.25;
}
.main {
  text-align: center;

  .how-to-join-title {
    margin: 30px 0 0 0;
    line-height: 1.6;
    font-size: 50px;
    font-weight: 900;
    display: inline-block;
    &::after {
      content: "";
      display: block;
      height: 10px;
      background: url("../../../assets/images/border/border_howto.svg");
      background-size: 101%;
    }
  }

  .about-title {
    margin: 80px 0 0 0;
  }

  .about-virtualrun {
    margin: 30px 0 0 0;
    line-height: 1.5;
    font-size: 16px;
    text-align: left;
  }

  .howtojoin-flow {
    margin: 100px 0 0 0;
  }

  .flow__list--item {
    padding: 20px 0;
    border-bottom: solid 1px var(--defaultBlackColor);
    position: relative;
    .step-title {
      line-height: 1.2;
    }
    &:not(:first-of-type) {
      .step-title {
        margin: 50px 0 0 0;
        position: relative;
        &::before {
          content: "";
          display: inline-block;
          width: 60px;
          height: 30px;
          background: url("../../../assets/images/triangle-bottom.png")
            no-repeat center / 60px 30px;
          position: absolute;
          top: -50px;
          left: 50%;
          transform: translate(-50%);
        }
      }
    }
    /*「重要対応」*/
    &:nth-of-type(3) {
      .step-title {
        margin: 70px 0 0 0;
        &::before {
          top: -70px;
        }
      }
    }
    .border-important {
      width: 100%;
      height: 390px;
      border: solid 1px var(--yellowFoundationColor);
      position: absolute;
      top: 77px;
      left: 50%;
      transform: translateX(-50%);
    }
    .height-en {
      height: 418px;
    }
    .important {
      width: 104px;
      height: 24px;
      font-size: 14px;
      font-weight: bold;
      color: ;
      background-color: var(--yellowFoundationColor);
      position: absolute;
      top: 66px;
      left: 50%;
      transform: translateX(-50%);
    }
    /*ここまで*/
    .status-label {
      display: inline-block;
      padding: 5px 13px;
      border: solid 1px var(--defaultBlackColor);
      line-height: 1;
      font-size: 11px;
      vertical-align: top;
      position: relative;
      &::after {
        content: "";
        display: inline;
        width: 40px;
        height: 5px;
        margin: 7px 0 0 0;
        background-color: var(--yellowFoundationColor);
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translate(-50%);
      }
    }
    .flow-title {
      margin: 32px 0 0 0;
    }
    .important-height {
      height: 84px;
    }
    .flow-img {
      margin: 20px 0 0 0;
    }
    .suggestion {
      margin: 20px 0 0 0;
    }
    .important-points {
      margin: 14px 0 0 0;
      line-height: 1.43;
      font-size: 14px;
      text-align: left;
      white-space: pre-line;
    }
    .pre-line-normal {
      white-space: normal;
    }
    .verification {
      margin: 20px 0 0 0;
      padding: 0 0 0 5px;
      border-left: solid 5px var(--defaultBlackColor);
      text-align: left;
      &__sentence {
        margin: 13px 0 0 0;
        line-height: 1.43;
        font-size: 14px;
        text-align: left;
      }
    }
  }

  /*スクロールした時の余白を保つために分けてる*/
  .app-to-use {
    margin: 80px 0 0 0;
    padding: 20px 0 0 0;
  }

  .app-description {
    margin: 30px 0 0 0;
    line-height: 1.5;
    font-size: 16px;
    text-align: left;
    white-space: pre-line;
  }

  .app-gallery {
    margin: 20px 0 0 0;
    padding: 25px 15px 12px;
    background-color: var(--defaultGrayColor);

    &__img {
      margin: 25px 0 0 0;
    }

    &__title {
      margin: 15px 0 0 0;
      font-size: 30px;
      font-weight: 900;
    }

    &__link {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 14px 0 0 0;
      a {
        display: contents;
        .android {
          margin: 0 0 0 12px;
        }
        img {
          height: 45px;
        }
        @media screen and (max-width: 356px) {
          img {
            height: 40px;
          }
        }
      }
    }
  }
  .important-title {
    margin: 100px 0 0 0;
  }
  .important-list {
    margin: 30px 0 0 0;
    line-height: 1.5;
    text-align: left;
    &__item {
      padding: 4px 0;
      &:nth-of-type(3),
      &:nth-of-type(4),
      &:nth-of-type(8),
      &:nth-of-type(9),
      &:nth-of-type(10),
      &:nth-of-type(11) {
        padding: 0 0 4px 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/howtojoin/CommonHowToJoin.vue